import React, { useEffect, createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';

const PageContext = createContext({});

export function PageContextProvider({ pageContext, children }) {
	const { i18n } = useTranslation();

	if (i18n.language !== pageContext.locale) {
		i18n.changeLanguage(pageContext.locale);
	}

	useEffect(() => {
		if (i18n.language !== pageContext.locale) {
			i18n.changeLanguage(pageContext.locale);
		}
	}, [pageContext.locale, i18n]);

	return <PageContext.Provider value={pageContext}>{children}</PageContext.Provider>;
}

export const usePageContext = () => useContext(PageContext);
